<template>
  <b-modal
    v-model="isVisible"
    hide-footer
    size="lg"
    @hidden="onHidden"
  >

    <b-card 
      style="border: 1px solid #c9c9c9"
      class="mt-3"
      v-if="derivacion && !loadingData"
    >
      <h3 class="text-center mb-3">Informacion de la derivacion</h3>

      <b-row>

        <span class="col-12">
          <b>Estado:</b> 
          <span> {{ estadoDerivacionText }}</span>
        </span>

        <span class="col-6">
          <b>Paciente:</b> 
          <span> {{ pacienteText }}</span>
        </span>

        <span class="col-6">
          <b>Fecha Derivacion:</b> 
          {{ fechaDerivacionText }}
        </span>

        <span class="col-6">
          <b>Tipo de Atencion:</b>
          <span> {{ tipoAtencionText }} </span>
        </span>

        <span class="col-6" v-if="showEspecialidad">
          <b>Especialidad Derivada:</b>
          {{ especialidadText }}
        </span>

        <span class="col-6">
          <b>Nivel Derivacion:</b>
          {{ nivelDerivacionText }}
        </span>
      </b-row>

      <hr>

      <b-row>
        <b-col class="col-6 mb-1">
          <b>Tipo de Documento:</b>
          <span> {{ tipoDocumentoText }}</span>
        </b-col>

        <b-col class="col-6 mb-1">
          <b>Motivo de derivacion:</b>
          <span> {{ motivoDerivacionText }}</span> 
        </b-col>

        <b-col class="col-12 mb-1">
          <b>Cuadro Clinico:</b>
          <span> {{ cuadroClinicoText }}</span> 
        </b-col>

        <b-col class="col-12 mb-1">
          <b>Hallazgos:</b>
          <span> {{ hallazgosText }}</span> 
        </b-col>

        <b-col class="col-12 mb-1" v-if='obsNegacionText'>
          <b>Comentarios sobre negacion:</b>
          <span> {{ obsNegacionText }}</span> 
        </b-col>

 
      </b-row>
      

      <b-row v-if="derivacion.diagnosticos">
        <span class="col-12 mb-2">
          <DiagnosticosList 
            v-model="derivacion.diagnosticos"
            onlyView
            class="my-1"
          />
        </span>
      </b-row>

      <b-card header="Servicio" style="border: 1px solid #c9c9c9" class="py-2">
        <b-row>
          <!--ATENCIONES -->
          <div
            v-if="derivacion.atenciones && derivacion.atenciones.length"
            class="col-12 mb-2"
          >
            <hr>
            <h5>Atenciones</h5>
            <b-table
              bordered
              striped
              responsive
              :items="derivacion.atenciones"
              :fields="fieldsTableAtenciones" 
            />
          </div>
          

          <!--PROCEDIMIENTOS -->   
          <div 
            class="col-12 mb-2" 
            v-if="derivacion.procedimientos && derivacion.procedimientos.length"
          >
            <hr>
            <h5>Procedimientos</h5>        
            <b-table
              bordered
              striped
              responsive
              :items="derivacion.procedimientos"
              :fields="fieldsTableProcedimientos" 
            />
          </div>

          <!--IMAGENES -->

          <div 
            v-if="derivacion.imagenes && derivacion.imagenes.length"
            class="col-12 mb-2"
          >
            <hr>
            <h5>Imagenes</h5>
            <b-table
              :items="derivacion.imagenes" 
              :fields="fieldsTableImagenes" 
              striped bordered responsive
            >
              <template #cell(imagentext)="data">
                {{ data.item.imagentext }} 
              </template>
              <template #cell(sedacion)="data">
                {{ data.item.sedacion === '1' ? 'Si' : 'No' }} 
              </template>
            </b-table>
          </div> 
          


          <!--LABORATORIO -->
          <b-table
            v-if="derivacion.laboratorios && derivacion.laboratorios.length"
            :items="derivacion.laboratorios"
            :fields="fieldsTableLaboratorios"
            class="text-center mb-2 col-12"
            responsive small
          />
            
        </b-row>
      </b-card>


      <b-card style="border: 1px solid #c9c9c9" class="py-2">
        <b-row>
          <b-col>
            <h6>Informes:</h6>

            <b-row
              v-if="showInforme053"
              class="mt-1"
            >
              <b-col>
                <span>Formulario 053:</span>

                <b-button
                  size="sm"
                  class="ml-2"
                  @click="onViewFile053(tokenDerivacion)"
                  :disabled="load053"
                >
                  <i class="fa-solid fa-file-arrow-down"/>
                </b-button>
              </b-col>
            </b-row>

            <b-row
              v-if="showInforme053"
              class="mt-1"
            >
              <b-col>
                <span>Tirilla:</span>

                <b-button
                  size="sm"
                  class="ml-2"
                  @click="onViewTirilla(derivacion.urlTirilla)"
                  :disabled="loadTirilla"
                >
                  <i class="fa-solid fa-file-arrow-down"/>
                </b-button>
              </b-col>
            </b-row>
            
          </b-col>
          
        </b-row>
      </b-card>

    </b-card>

    <GeneralLoader v-if="loadingData" :size="100" class="my-5"/>

    <ModalViewFile
      v-if="modalFile.fileToView"
      :urlFile="modalFile.fileToView"
      :rutaCompleta=modalFile.isRutaCompleta
      v-model="modalFile.isVisible"
    />

  </b-modal>
</template>


<script>
import { DiagnosticosList, GeneralLoader, ModalViewFile } from '@/shared/components';
import { getEstablecimientoLS, getItemByValueId } from '@/shared/helpers';
import { derivacionesService } from '../../services';

export default {
  name: "DerivacionModalView",

  components: {
    DiagnosticosList,
    GeneralLoader,
    ModalViewFile
  },

  data(){
    return {
      isVisible: false,
      tokenDerivacion:null,
      derivacion:{},

      loadingData: false,

      tipoAtencionOpts: [
        { value: '1', text: "Consulta Externa" },
        { value: '2', text: "Laboratorio" },
        { value: '3', text: "Imagen" },
        { value: '4', text: "Procedimientos Diagnósticos" },
        { value: '5', text: "Hospitalización" },
        { value: '6', text: "Emergencia" },
        { value: '7', text: "Tratamiento Integral Oncologico" }
      ],

      fieldsTableProcedimientos: [
        {
          key: "text",
          label: "Codigo - Descripcion",
          sortable: true,
          thClass: "text-center",
        },
      ],

      fieldsTableAtenciones: [
        {
          key: "text",
          label: "Codigo - Descripcion",
          sortable: true,
          thClass: "text-center",
        },
      ],

      fieldsTableImagenes: [
        { key:'imagentext',      label:'Imagen',                thClass: 'text-center' },
        { key:'lateralidad',     label:'Lateralidad',           thClass:'text-center' },
        { key:'motivosolicitud', label:'Motivo de Solicitud',   thClass:'text-center' },
        { key:'resumen',         label:'Resumen Clínico',       thClass:'text-center' },
        { key:'sedacion',        label:'Sedacion',              thClass:'text-center' },
      ],

      fieldsTableLaboratorios: [
        { key: "descripcion",  label: "Codigo - Descripcion", thClass: "text-center" },
      ],

      modalFile:{
        fileToView: null,
        isVisible: false,
        isRutaCompleta: false
      },

      load053: false,
      loadTirilla: false
    }
  },


  created() {
    this.setTokenDerivacion();
  },


  methods: {

    onHidden() {
      this.$store.commit('setModalCompletarDerivacion', { zData: null } );
      this.$store.commit('setModalCompletarDerivacion', { dataForm: null } );
    },
    
    async onGetDataDerivacion(){

      if(!this.tokenDerivacion) return;
      const dataDerivacion = await derivacionesService.getByToken(this.tokenDerivacion);
      if(!dataDerivacion){
        await this.$swal("Error, la derivacion no existe", "error")
        this.isVisible = false;
        return;
      }
      
      // mapper

      const estadoDerivacion = dataDerivacion.estadoDerivacion;

      const dataPaciente = dataDerivacion.atenmedId.cita.paciente;
      
      const paciente  = dataPaciente
        ? { 
          id: dataPaciente.id,
          nombre: `${dataPaciente.persona.primerApellido} ${dataPaciente.persona.primerNombre}`,
        }
        : null; 


      const dataTipoAtencion = dataDerivacion.tipoAtencion;

      const tipoAtencion = dataTipoAtencion
        ? getItemByValueId(this.tipoAtencionOpts, dataTipoAtencion)
        : null;


      const especialidad = {
        value : dataDerivacion.especialidad?.id,
        text  : dataDerivacion.especialidad?.descripcion,
        codEsp: dataDerivacion.especialidad?.codEsp
      }

      const esUrgente = dataDerivacion.esurgente === '1';

      const tipoDocumento = dataDerivacion.tipoderivacionId 
        ? {
          value: dataDerivacion.tipoderivacionId?.id,
          text: dataDerivacion.tipoderivacionId?.descripcion
        } 
        : null;

      const motivoDerivacion = dataDerivacion.motivoderivacionId
        ? {
          value: dataDerivacion.motivoderivacionId?.id,
          text: dataDerivacion.motivoderivacionId?.descripcion
        }
        : null;


      const diagnosticos = dataDerivacion.diagnosticoDerivacion
        ? JSON.parse(dataDerivacion.diagnosticoDerivacion)
        : [];

      console.log('dataDerivacion', dataDerivacion);

      const hallazgos = dataDerivacion.hallazgosDerivacion;

      const imagenes = dataDerivacion.imagenesDerivacion 
        ? JSON.parse(dataDerivacion.imagenesDerivacion)
        : [];

      const laboratorios = dataDerivacion.laboratoriosDerivacion 
        ? JSON.parse(dataDerivacion.laboratoriosDerivacion)
        : [];

      const procedimientos = dataDerivacion.procedimientoDerivacion 
        ? JSON.parse(dataDerivacion.procedimientoDerivacion)
        : [];

      const atenciones = dataDerivacion.atencionDerivacion 
        ? JSON.parse(dataDerivacion.atencionDerivacion)
        : [];

      const derivacionMapped = {
        estadoDerivacion     : estadoDerivacion,
        paciente             : paciente,
        fechaDerivacion      : dataDerivacion.fechaDerivacion,
        tipoAtencion         : tipoAtencion,
        especialidad         : especialidad,
        esUrgente            : esUrgente,
        tipoDocumento        : tipoDocumento,
        motivoDerivacion     : motivoDerivacion,
        cuadroClinico        : dataDerivacion.cuadroClinico,
        hallazgos            : hallazgos,
        diagnosticos         : diagnosticos,
        imagenes             : imagenes,
        laboratorios         : laboratorios,
        urlTirilla           : dataDerivacion.urlTirillaDerivacion,
        procedimientos       : procedimientos,
        atenciones           : atenciones,
        obsNegacion          : dataDerivacion.obsNegacion
      };
      
      this.derivacion = derivacionMapped;
      this.isVisible = true;
      this.$store.commit('setModalCompletarDerivacion', { zData: derivacionMapped } );
    },


    setTokenDerivacion(){
      this.tokenDerivacion = this.$route.query.view_derivacion;
      this.derivacion = {};
    },

    async onViewFile053(tokenInterconsulta) {
      
      this.load053 = true;
      const urlTemp = await derivacionesService.getUrlView053(tokenInterconsulta);
      if (!urlTemp) {
        this.load053 = false;
        this.$swal({
          title: 'Error',
          text: "El archivo no existe, comunicar con el personal de derivaciones",
          icon: 'error',
        })
      }

      this.modalFile.isRutaCompleta = true;
      this.modalFile.fileToView = urlTemp;
      this.modalFile.isVisible = true;
      this.load053 = false;
    },

    async onViewTirilla(urlTirilla) {
      if (!urlTirilla) {
        this.loadTirilla = false;
        this.$swal({
          title: 'Error',
          text: "El archivo no existe, comunicar con el personal de derivaciones",
          icon: 'error',
        });
      }
      this.modalFile.isRutaCompleta = false;
      this.modalFile.fileToView = urlTirilla;
      this.modalFile.isVisible = true;
      this.loadTirilla = false;
    },

  },

  


  computed:{

    estadoDerivacionText(){
      return this.derivacion.estadoDerivacion === '99' ? 'Por Completar' : 'Creado';
    },

    showEspecialidad(){
      const show = ['2', '3'].some((item) => item === this.derivacion?.tipoAtencion?.value);
      return !show;
    },

    pacienteText(){
      return this.derivacion.paciente?.nombre || 'No asignado';
    },


    fechaDerivacionText(){
      return this.derivacion.fechaDerivacion || 'No asignado';
    },

    tipoAtencionText(){
      return this.derivacion.tipoAtencion?.text || 'No asignado';
    },

    nivelDerivacionText(){
      const establecimiento = getEstablecimientoLS();
      let nivel = null;

      if (['1', '3', '4'].some(id => id === establecimiento.id)) 
        nivel = 1;

      if (['2', '5', '6'].some(id => id === establecimiento.id)) 
        nivel = 2;
      
      return nivel;
    },


    tipoDocumentoText(){
      return this.derivacion.tipoDocumento?.text || 'No asignado';
    },

    motivoDerivacionText(){
      return this.derivacion.motivoDerivacion?.text || 'No asignado';
    },

    cuadroClinicoText(){
      return this.derivacion.cuadroClinico || 'No asignado';
    },

    hallazgosText(){
      return this.derivacion.hallazgos || 'No asignado';
    },
    obsNegacionText(){
      let comentNega = null
      if(this.derivacion.obsNegacion){
        comentNega = this.derivacion.obsNegacion.toUpperCase()
      }
      return comentNega;
    },
    
    establecimientoText(){
      return this.derivacion.establecimiento?.text || 'No asignado';
    },

    especialidadText(){
      return this.derivacion.especialidad?.text || 'No asignado';
    },

    estadoText(){
      return this.derivacion.estado?.text || 'No asignado';
    },

    servicioText(){
      return this.derivacion.servicio?.text || 'No asignado';
    },

    showInforme053(){
      return this.derivacion.estadoDerivacion !== '99';
    }
  },


  watch: {
    '$route.query.view_derivacion': {

      handler() {
        this.setTokenDerivacion();
      },
    },

    tokenDerivacion:{
      deep: true,
      handler(newValue){
        if(!newValue) return;
        this.onGetDataDerivacion(newValue);
      }
    },

    isVisible: {
      deep: true,
      handler(newValue) {
        if (!newValue) {
          const updatedQuery = { ...this.$route.query };
          delete updatedQuery.view_derivacion;
          this.$router.push({ path: this.$route.path, query: updatedQuery });
        }
      }
    }

  },

}
</script>